import getCurrentSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import getDefaultDisposalType from 'mini-mail-reading-pane-store/lib/utils/getDefaultDisposalType';
import isItemView from 'owa-mail-store/lib/utils/isItemView';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import {
    lazyDeleteConversation,
    lazyDeleteItemFromReadingPane as lazyDeleteItem,
} from 'mini-mail-triage-actions';
import { TriageActionSource } from 'mini-mail-triage-actions/lib/schema/TriageActionSource';

export const deleteMailListRow = (rowId: string, shouldIssueDeleteServiceCall?: boolean) => {
    const currentTableView = getCurrentSelectedTableView();

    if (isItemView(currentTableView)) {
        lazyDeleteItem({
            itemId: rowId,
            disposalType: getDefaultDisposalType(rowId),
            source: 'ListView',
            shouldSupportUndoAction: false,
            shouldIssueDeleteServiceCall: shouldIssueDeleteServiceCall,
        });
    } else {
        const conversationItem = getListViewStore().conversationItems.get(rowId);
        const noOfItemsInConversation = conversationItem?.globalItemIds
            ? conversationItem.globalItemIds.length
            : 0;
        lazyDeleteConversation({
            conversationId: conversationItem?.id,
            originalTableViewId: currentTableView?.id,
            noOfItemsInConversation,
            sourceView: TriageActionSource.ListView,
            shouldSupportUndoAction: false,
            shouldIssueDeleteServiceCall: shouldIssueDeleteServiceCall,
        });
    }
};
